import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';

/**
 * Phone width, where list pages drop the table height cap and scroll as one page. The FA-Suite Technician module's
 * phone query, which matches CCL's own inclusive 768px breakpoint.
 */
export const PHONE_MEDIA_QUERY = '(max-width: 768px)';

/** True below 768px. Call in an injection context (a field initializer or constructor). */
export function injectIsPhone(): Signal<boolean> {
  return toSignal(
    inject(BreakpointObserver)
      .observe(PHONE_MEDIA_QUERY)
      .pipe(map((state) => state.matches)),
    { initialValue: window.matchMedia(PHONE_MEDIA_QUERY).matches }
  );
}
